import { cn } from '@eo/shared';

import { ROLE_BAR_CLASS, ROLE_DOT_CLASS } from './constants';
import { formatHours } from './helpers';
import { LoadBar } from './LoadBar';
import type { TeamDeliveryProps } from './types';

// Logged hours against the hours each side and person holds, on one scale so a longer bar
// is always more hours. Only logged hours fill the bar: a faded "still to log"
// fill ended exactly at the tick and read as progress.
export function TeamDelivery({ rows, testId }: TeamDeliveryProps) {
  const scale = Math.max(0, ...rows.map((r) => Math.max(r.held, r.logged)));

  return (
    <ul data-testid={testId} className="flex flex-col gap-4">
      {rows.map((row) => {
        const over = row.logged - row.held;
        return (
          <li key={row.key} className="flex flex-col gap-2">
            <div className="flex flex-wrap items-baseline justify-between gap-2 text-sm">
              <span className="flex items-center gap-2 text-text-primary">
                <span className={cn('size-2.5 rounded-[2px]', ROLE_DOT_CLASS[row.role])} />
                {row.label}
              </span>
              <span className="tabular-nums text-text-secondary">
                {formatHours(row.logged)} of {formatHours(row.held)}
                {over > 0 && (
                  <span className="ml-2 text-destructive">{formatHours(over)} over</span>
                )}
              </span>
            </div>
            <LoadBar
              label={`${row.label}: ${formatHours(row.logged)} logged of ${formatHours(row.held)} held`}
              scale={scale}
              target={row.held}
              targetHint={`Held ${formatHours(row.held)}: the hours ${row.label} holds this month. Hours logged past this line are over.`}
              segments={[
                { key: 'logged', hours: row.logged, className: ROLE_BAR_CLASS[row.role].logged },
              ]}
            />
          </li>
        );
      })}
    </ul>
  );
}
